import { randomNumber } from '../../../utilities'
import { AddMedicationAdministeredConstants } from './addMedicationAdministered.constants'
import {
  IAddMedicationAdministered,
  IAddMedicationAdministeredAction,
  IAddMedicationAdministeredState,
} from './addMedicationAdministered.types'

export const initialAddMedicationAdministered = (): IAddMedicationAdministered => {
  return {
    key: randomNumber().toString(),
    medication: null,
    dose: null,
    doseUnit: null,
    doseUnitPNNV: null,
    rate: null,
    rateUnit: null,
    frequency: null,
    route: null,
    routePNNV: null,
    concentration: '',
    response: null,
    responsePNNV: null,
    complications: [],
    wasted: false,
    lotNumber: '',
    witness1: '',
    witness2: '',
  }
}

export const initialAddMedicationAdministeredState: IAddMedicationAdministeredState = {
  key: randomNumber().toString(),
  date: '',
  time: '',
  pta: false,
  dateTime: '',
  assessedBy: null,
  rolePerforming: null,
  rolePerformingPNNV: null,
  administeredByAnotherUnit: null,
  administeredByAnotherUnitPNNV: null,
  medication: null,
  dose: null,
  doseUnit: null,
  doseUnitPNNV: null,
  rate: null,
  rateUnit: null,
  frequency: null,
  route: null,
  routePNNV: null,
  concentration: '',
  response: null,
  responsePNNV: null,
  complications: [],
  authorization: null,
  wasted: false,
  lotNumber: '',
  witness1: '',
  witness2: '',
  medicationAdministered: null,
  comments: '',
  addMedicationAdministeredData: [],
  areMedicationsOptionsLoading: false,
  addToTimeline: false,
  type: 'Medication',
  currentMedication: null,
  isEkgImport: null,
  medicationDefaults: null,
  nemsisCode: null,
}

export function addMedicationAdministeredReducer(
  state: IAddMedicationAdministeredState = initialAddMedicationAdministeredState,
  action: IAddMedicationAdministeredAction
): IAddMedicationAdministeredState {
  switch (action.type) {
    case AddMedicationAdministeredConstants.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case AddMedicationAdministeredConstants.SET_TIME:
      return { ...state, time: action.time }
    case AddMedicationAdministeredConstants.SET_DATE:
      return { ...state, date: action.date }
    case AddMedicationAdministeredConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case AddMedicationAdministeredConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case AddMedicationAdministeredConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case AddMedicationAdministeredConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case AddMedicationAdministeredConstants.SET_ADMINISTERED_BY_OTHER_UNIT:
      return { ...state, administeredByAnotherUnit: action.administeredByAnotherUnit }
    case AddMedicationAdministeredConstants.SET_ADMINISTERED_BY_OTHER_UNIT_PNNV:
      return { ...state, administeredByAnotherUnitPNNV: action.administeredByAnotherUnitPNNV }
    case AddMedicationAdministeredConstants.SET_MEDICATION:
      return { ...state, medication: action.medication, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_DOSE:
      return { ...state, dose: action.dose, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_DOSE_UNIT:
      return { ...state, doseUnit: action.doseUnit, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_DOSE_UNIT_PNNV:
      return { ...state, doseUnitPNNV: action.doseUnitPNNV, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_RATE:
      return { ...state, rate: action.rate, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_RATE_UNIT:
      return { ...state, rateUnit: action.rateUnit, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_FREQUENCY:
      return { ...state, frequency: action.frequency, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_ROUTE:
      return { ...state, route: action.route, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_ROUTE_PNNV:
      return { ...state, routePNNV: action.routePNNV, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_CONCENTRATION:
      return { ...state, concentration: action.concentration, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_RESPONSE_VALUE:
      return {
        ...state,
        response: action.response,
        medicationAdministered: action.medicationAdministered,
      }
    case AddMedicationAdministeredConstants.SET_RESPONSE_VALUE_PNNV:
      return {
        ...state,
        responsePNNV: action.responsePNNV,
        medicationAdministered: action.medicationAdministered,
      }
    case AddMedicationAdministeredConstants.SET_COMPLICATIONS:
      return { ...state, complications: action.complications, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_WASTED:
      return {
        ...state,
        wasted: action.wasted,
        type: action.wasted ? 'Wasted Medication' : 'Medication',
        medicationAdministered: action.medicationAdministered,
      }
    case AddMedicationAdministeredConstants.SET_LOT_NUMBER:
      return { ...state, lotNumber: action.lotNumber, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_WITNESS_1:
      return { ...state, witness1: action.witness1, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_WITNESS_2:
      return { ...state, witness2: action.witness2, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case AddMedicationAdministeredConstants.SET_MEDICATION_ADMINISTERED:
      return { ...state, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_CURRENT_MEDICATION:
      return { ...state, currentMedication: action.currentMedication }
    case AddMedicationAdministeredConstants.ADD_MEDICATION_ADMINISTERED:
      return {
        ...state,
        addMedicationAdministeredData: [...state.addMedicationAdministeredData, initialAddMedicationAdministered()],
      }
    case AddMedicationAdministeredConstants.DELETE_MEDICATION_ADMINISTERED:
      return { ...state, medicationAdministered: action.medicationAdministered }
    case AddMedicationAdministeredConstants.SET_ADD_MEDICATION_ADMINISTERED_DATA:
      return {
        ...state,
        addMedicationAdministeredData: action.addMedicationAdministeredData,
      }
    case AddMedicationAdministeredConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case AddMedicationAdministeredConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case AddMedicationAdministeredConstants.SET_MEDICATION_DEFAULTS:
      return { ...state, medicationDefaults: action.medicationDefaults }
    case AddMedicationAdministeredConstants.SET_STATE:
      return { ...action.addMedicationAdministeredState }
    case AddMedicationAdministeredConstants.RESET_STATE:
      return {
        key: randomNumber().toString(),
        date: '',
        time: '',
        pta: false,
        dateTime: '',
        assessedBy: null,
        rolePerforming: null,
        rolePerformingPNNV: null,
        administeredByAnotherUnit: null,
        administeredByAnotherUnitPNNV: null,
        medication: null,
        dose: null,
        doseUnit: null,
        doseUnitPNNV: null,
        rate: null,
        rateUnit: null,
        frequency: null,
        route: null,
        routePNNV: null,
        concentration: '',
        response: null,
        responsePNNV: null,
        complications: [],
        authorization: null,
        wasted: false,
        lotNumber: '',
        witness1: '',
        witness2: '',
        medicationAdministered: null,
        comments: '',
        addMedicationAdministeredData: [],
        areMedicationsOptionsLoading: false,
        addToTimeline: false,
        type: 'Medication',
        currentMedication: null,
        isEkgImport: null,
        medicationDefaults: null,
        nemsisCode: null,
      }
    default:
      return state
  }
}
